export interface Review {
  id: number;
  comicId: number;
  comicTitle: string;
  userName: string;
  avatar: string;
  rating: number;
  content: string;
  time: string;
  likes: number;
}

export const reviews: Review[] = [
  {
    id: 1,
    comicId: 1,
    comicTitle: '斗破苍穹',
    userName: '萧炎本炎',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20male%20avatar%20with%20flame%20theme%2C%20simple%20background%2C%20clean%20illustration&width=100&height=100&seq=avatar-review-01&orientation=squarish',
    rating: 5,
    content: '追了五年了，从初中看到大学，萧炎的成长历程真的太热血了！每次看到他从绝境中突破都让人热泪盈眶。天蚕土豆的剧情把控真的牛，强推！',
    time: '2026-07-07',
    likes: 3280,
  },
  {
    id: 2,
    comicId: 12,
    comicTitle: '镖人',
    userName: '江湖夜雨',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20warrior%20avatar%2C%20simple%20background%2C%20clean%20traditional%20art&width=100&height=100&seq=avatar-review-02&orientation=squarish',
    rating: 5,
    content: '这才是真正的国漫之光！许先哲老师的画风太有味道了，每一格都可以当壁纸。刀马这个角色塑造得太好了，有血有肉，江湖气息扑面而来。',
    time: '2026-07-06',
    likes: 4521,
  },
  {
    id: 3,
    comicId: 11,
    comicTitle: '非人哉',
    userName: '九月的小迷弟',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20Chinese%20cartoon%20style%20fox%20avatar%2C%20simple%20background%2C%20clean%20illustration&width=100&height=100&seq=avatar-review-03&orientation=squarish',
    rating: 5,
    content: '哈哈哈哈哈哈每集都能笑到头掉！九月太可爱了，敖烈太憨了，杨戬的哮天犬日常我能看一百遍！工作压力大的时候就看这个解压。',
    time: '2026-07-08',
    likes: 2890,
  },
  {
    id: 4,
    comicId: 2,
    comicTitle: '一人之下',
    userName: '异人世界',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20anime%20style%20male%20avatar%20with%20mysterious%20aura%2C%20simple%20background%2C%20clean%20illustration&width=100&height=100&seq=avatar-review-04&orientation=squarish',
    rating: 4,
    content: '米二的脑洞真的服气！道家文化+现代都市的组合太绝了。冯宝宝这个角色简直是国漫史上最独特的女主角，又憨又强，爱了爱了。',
    time: '2026-07-05',
    likes: 2150,
  },
  {
    id: 5,
    comicId: 5,
    comicTitle: '大理寺日志',
    userName: '猫奴本奴',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20white%20cat%20avatar%20in%20Chinese%20traditional%20style%2C%20simple%20background%2C%20clean%20illustration&width=100&height=100&seq=avatar-review-05&orientation=squarish',
    rating: 5,
    content: '少卿大人太萌了！一只猫当大理寺卿这个设定简直天才。而且剧情质量出乎意料的高，破案推理部分很有水准，不是纯搞笑番。',
    time: '2026-07-04',
    likes: 1870,
  },
  {
    id: 6,
    comicId: 8,
    comicTitle: '全职高手',
    userName: '荣耀十年',
    avatar: 'https://readdy.ai/api/search-image?query=Esports%20gaming%20themed%20Chinese%20anime%20style%20avatar%2C%20simple%20background%2C%20clean%20illustration&width=100&height=100&seq=avatar-review-06&orientation=squarish',
    rating: 5,
    content: '叶修yyds！从被驱逐到重回巅峰，每一步都看得人热血沸腾。蝴蝶蓝把电竞写得这么燃也是没谁了，千机伞这个设定真的绝妙。',
    time: '2026-07-03',
    likes: 3980,
  },
  {
    id: 7,
    comicId: 3,
    comicTitle: '狐妖小红娘',
    userName: '相思树下',
    avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20anime%20style%20female%20avatar%20with%20pink%20theme%2C%20simple%20background%2C%20clean%20illustration&width=100&height=100&seq=avatar-review-07&orientation=squarish',
    rating: 5,
    content: '泪目了，每一世的故事都让人感动到不行。涂山苏苏和白月初的爱情太美好了。"如果我们能活着出去，万水千山你愿意陪我一起看吗？"这句台词记到现在。',
    time: '2026-07-02',
    likes: 5120,
  },
  {
    id: 8,
    comicId: 4,
    comicTitle: '镇魂街',
    userName: '守护灵使者',
    avatar: 'https://readdy.ai/api/search-image?query=Guardian%20spirit%20themed%20Chinese%20anime%20style%20avatar%2C%20simple%20background%2C%20clean%20illustration&width=100&height=100&seq=avatar-review-08&orientation=squarish',
    rating: 4,
    content: '守护灵这个设定太酷了！每个守护灵的设计都很用心，战斗场面也画得很有张力。曹焱兵和许褚的主仆情谊真的让人动容。',
    time: '2026-07-01',
    likes: 1650,
  },
  {
    id: 9,
    comicId: 6,
    comicTitle: '星海镖师',
    userName: '星际漫游者',
    avatar: 'https://readdy.ai/api/search-image?query=Sci-fi%20space%20themed%20Chinese%20anime%20style%20avatar%2C%20simple%20background%2C%20clean%20illustration&width=100&height=100&seq=avatar-review-09&orientation=squarish',
    rating: 4,
    content: '颜开老师的科幻世界观构建得太宏大了，每个星球都有独特的文化和设定。唐小镖从一个菜鸟到独当一面的镖师，成长线写得很扎实。',
    time: '2026-06-30',
    likes: 1280,
  },
];

export const getReviewsByComicId = (comicId: number): Review[] => {
  return reviews.filter((r) => r.comicId === comicId);
};